module.exports = __webpack_public_path__ + "img/thumbnail_AfricanLeopard_j_melanistic.794522b4.png";